//@ts-nocheck
import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom';
import { QueryClientProvider } from 'react-query';
import { ToastContainer } from 'react-toastify';
import { queryClient } from 'clients/api';
import { Web3Wrapper } from 'clients/web3';
import { AuthProvider } from 'context/AuthContext';
import { SuccessfulTransactionModalProvider } from 'context/SuccessfulTransactionModalContext';
import { store } from 'core';
import { Layout, ResetScrollOnRouteChange } from 'components';
import { isOnTestnet } from 'config';
import Dashboard from 'pages/Dashboard';
import Faucet from 'containers/Main/Faucet';
import VoteV1 from 'containers/Main/Vote';
import Vote from 'pages/Vote';
import Brn from 'pages/Brn';
// import Market from 'pages/Market';
import Market from './MarketV2';
import Vault from 'pages/Vault';
import VaultV1 from 'containers/Main/Vault';
import VoteOverview from 'containers/Main/VoteOverview';
import Proposal from 'pages/Proposal';
import ProposerDetail from 'containers/Main/ProposerDetail';
import VoterLeaderboard from 'containers/Main/VoterLeaderboard';
import ConvertVrt from 'pages/ConvertVrt';
import MarketDetails from 'pages/MarketDetails';
import History from 'pages/History';
import NFTMarket from 'pages/NFTMarket'
import Theme from 'theme';
import { RefreshContextProvider } from 'context/RefreshContext';
import { NFTContextProvider } from 'context/NFTContext';
import { MarketContextProvider } from 'context/MarketContext';
import { BaiContextProvider } from 'context/BaiContext';
import { MuiThemeProvider } from 'theme/MuiThemeProvider/MuiThemeProvider';
import Path from 'constants/path';
import 'assets/styles/App.scss';
import Home from 'homeComponents/Home/Home';

const App = () => (
  <Theme>
    <Web3Wrapper>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <MuiThemeProvider>
            <RefreshContextProvider>
              <AuthProvider>
                <BaiContextProvider>
                  <MarketContextProvider>
                    <NFTContextProvider>
                    <SuccessfulTransactionModalProvider>
                      <BrowserRouter>
                        <ToastContainer />
                        <Switch>
                          <Route exact path={Path.ROOT} component={Home} />
                          <Layout>
                            <ResetScrollOnRouteChange />
                            <Route exact path={Path.DASHBOARD} component={Dashboard} />
                            <Route exact path={Path.MARKET} component={Market} />
                            <Route exact path={Path.MARKET_DETAILS} component={MarketDetails} />

                            <Route
                              exact
                              path={Path.FARM}
                              component={process.env.REACT_APP_RUN_V2 ? Vault : VaultV1}
                            />

                            {/* <Route
                              exact
                              path={process.env.REACT_APP_RUN_V2 ? Path.HISTORY : Path.TRANSACTION}
                              component={History}
                            /> */}

                            {/* <Route
                              exact
                              path={Path.VOTE}
                              component={process.env.REACT_APP_RUN_V2 ? Vote : VoteV1}
                            />
                            <Route
                              exact
                              path={Path.VOTE_LEADER_BOARD}
                              component={VoterLeaderboard}
                            />
                            <Route exact path={Path.VOTE_ADDRESS} component={ProposerDetail} />
                            <Route
                              exact
                              path={Path.VOTE_PROPOSAL_DETAILS}
                              component={process.env.REACT_APP_RUN_V2 ? Proposal : VoteOverview}
                            /> */}

                            <Route exact path={Path.BRN} component={Brn} />
                            <Route exact path={Path.NFTMARKET} component={NFTMarket}/>

                            {/* <Route exact path={Path.CONVERT_VRT} component={ConvertVrt} /> */}

                            {isOnTestnet && <Route exact path={Path.FAUCET} component={Faucet} />}

                            {/* <Redirect to={Path.DASHBOARD} /> */}
                          </Layout>
                        </Switch>
                      </BrowserRouter>
                    </SuccessfulTransactionModalProvider>
                    </NFTContextProvider>
                  </MarketContextProvider>
                </BaiContextProvider>
              </AuthProvider>
            </RefreshContextProvider>
          </MuiThemeProvider>
        </Provider>
      </QueryClientProvider>
    </Web3Wrapper>
  </Theme>
);

export default App;
